/**
 * 切换多语言
 */
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import languageController from '@ctrls/languageController'
import { restaurantConfig } from 'restaurant'
import languageMobx from '@mobx/app/language.mobx'
import zhImg from '@img/i18n/zh.png'
import deImg from '@img/i18n/de.png'
import enImg from '@img/i18n/en.png'
import './index.scss'

interface IProps {
}

const iconLang = {
  'zh-CN': zhImg,
  'en-US': enImg,
  'de-DE': deImg
}
const LanguageSwitch: React.FC<IProps> = (props) => {
  const { language } = restaurantConfig
  const { languageList = [navigator.language] } = languageMobx
  const currentIndex = languageList.findIndex((item) => language === item) || 0
  const nextIndex = currentIndex >= languageList.length - 1 ? 0 : currentIndex + 1
  const handleClick = () => {
    const nextLang = languageList[nextIndex] as TLanguage
    languageController.changeLanguage(nextLang)
  }

  return languageList.length > 1 && (
    <Fragment key='language-switch'>
      <div className='language-switch-container'>
        <div className='language-switch-wrapper' data-cypid='languageSwitch' onClick={handleClick}>
          <img className='language-img' src={iconLang[language]} alt='' />
        </div>
      </div>
    </Fragment>
  )
}

export default observer(LanguageSwitch)
